import type {MaterialStorage} from '@domain/material-storage'
import {DeleteOutline} from '@mui/icons-material'
import {useCallback} from 'react'
import {Trans, useTranslation} from 'react-i18next'

import {useConfirmDialog} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'
import {useDeleteStorage} from '@settings/modules/storages/hooks'

export const useHandleDeleteStorageFromPlanning = (storage?: MaterialStorage) => {
  const {t} = useTranslation()
  const {openDialog} = useConfirmDialog()
  const plantCode = useUrlParam('plantCode')

  const {mutate: deleteStorage, isPending: isDeletingStorage} = useDeleteStorage()

  const handleDeleteStorageFromPlanning = useCallback(() => {
    if (!storage) throw new Error('Delete from planning is not allowed')

    openDialog({
      title: t('storagesSettings.deleteStorage'),
      mainAction: {
        color: 'error',
        text: t('common.delete'),
        icon: <DeleteOutline />,
        onAction: () => deleteStorage({plantCode, id: storage.id})
      },
      additionalContent: (
        <Trans
          i18nKey="plantSetup.deleteFromPlanningWarning"
          values={{name: storage.name}}
        />
      )
    })
  }, [storage, plantCode, t, openDialog, deleteStorage])

  return {
    isDeletingStorage,
    handleDeleteStorageFromPlanning
  }
}
